<template>
  <div class="form-body col-md-8 col-sm-12">
    <v-row class="form-item-section personal-info-section">
      <v-row class="personal-info-row p-b-15" v-slimscroll>
        <v-col cols="12" sm="12" md="12" class="heading">
          <h3>SITE TERMS & CONDITIONS OF USE</h3>
        </v-col>
        <v-col cols="12" sm="12" md="12" class="personal-input-wrapper">
          <strong>Effective Date: 1 June 2022</strong>
          <br/>
          <br/>
          <strong style="color: #ff0000;">
            PLEASE READ THESE TERMS AND CONDITIONS OF USE (“TERMS”) CAREFULLY BEFORE USING THIS SITE.
          </strong>
          <br/>
          <br/>
          Welcome to <a href="https://yachtcover.map.marsh.com/webportal/Thailand/">https://yachtcover.map.marsh.com/webportal/Thailand/</a>. We refer to this website or application and its entire contents, features, design, and functionality as the “Site.”  This Site is operated by Marsh PB Co., Ltd (“Marsh”).
          <br/>
          <br/>
          This Site is intended for access and use by authorized users only (“Authorized Users”).  By using this Site, you represent and warrant that you are an Authorized User, and that you have read and accept the following Terms.
          <br/>
          <h4>Your Acceptance of these Terms</h4>
          <ol>
            <li>
              <b>You Accept Posted Terms.</b>  Any time you make use of this Site, you, on behalf of yourself and your organization, agree to comply with and be bound by the Terms in effect on your date of access (see “effective date” above).  If you do not agree to be bound by the Terms or do not have the authority to bind your organization to these Terms, you should not access or view this Site.
            </li>
            <li>
              <strong>You Accept Amendments to Terms.</strong>
              Please be aware that Marsh may amend the Terms from time to time.  While, at its sole discretion, Marsh may require you to directly acknowledge your acceptance of these Terms, including upon material changes to the Terms, <span class="underLine">you are on notice that your ongoing use of the Site alone constitutes your acceptance of the Terms and any changes.</span>  If we make changes to these Terms, we will update the “Effective Date” at the top of the page.  Accordingly, please continue to review the Terms whenever accessing the Site.
            </li>
            <li>
              <strong>You are Legally Capable of Accepting the Terms.</strong>
              You are at least 18 years old and/or possess the legal authority to form legally binding contracts under applicable law to use this Site.
            </li>
            <li>
              <strong>Your Other Written Agreements are Separate From These Terms.</strong>
              These Terms govern your use of this Site and are separate from the terms or conditions of any other agreements you have entered into with Marsh.
            </li>
            <h4>
              Your Rights and Obligations as a User of this Site
            </h4>
            <li>
              <strong>Your Permitted Use.</strong>
              You may access and use this Site for the sole purpose that this Site has been made available to you by Marsh (the “Purpose”).  You shall not access or use this Site for any other reason other than the Purpose including, without limitation, penetration testing or any of the prohibited uses set forth below.
            </li>
            <li>
              <strong>Your Account.</strong>
              In order to use this Site, you may be required to register an account.  <span class="underLine">You are entirely responsible for maintaining the confidentiality of your login credentials, if applicable, and for all activities undertaken by any party using your account.</span>  You agree to notify Marsh immediately if you become aware of any unauthorized use of your account or other breach of security.  <span class="underLine">Marsh will not be liable for any loss you incur based on another party’s use of your account, either with or without your consent, but your actions may make you liable for losses sustained by Marsh or others.</span>  You agree not to use anyone else's account without the express permission of the account holder and Marsh’s authorization.
            </li>
            <li>
              <strong>
                Prohibited Uses.
              </strong>
              You agree not to make any use of this Site that:
              <br/>
              <ul class="disc">
                <li>
                  is illegal, fraudulent, or abusive;
                </li>
                <li>
                  is defamatory or obscene;
                </li>
                <li>
                  could compete with the business of Marsh, its business partners, or licensees;
                </li>
                <li>
                  offers Site access or content for sale, assignment, sublicensing, or otherwise makes the content available to a third party;
                </li>
                <li>
                  violates the intellectual property or ownership rights of Marsh or a third party, including making derivative works based on the Site;
                </li>
                <li>
                  could interfere with any third party's use and enjoyment of the Site;
                </li>
                <li>
                  introduces viruses or other harmful programs or code;
                </li>
                <li>
                  circumvents passwords, access controls, captchas, robot.txt scripts and similar technologies intended to protect users and/or our intellectual property;
                </li>
                <li>
                  archives, mines, or harvests any personal information, intellectual property or any part of this Site;
                </li>
                <li>
                  Tests the security of the Site or otherwise attempts to gain unauthorized access to the confidential information of Marsh or its other clients, or to Marsh’s computer systems or networks connected to any Marsh server through hacking, password mining, or any other means;
                </li>
                <li>
                  could damage, disable, overburden, or impair any Marsh server or the networks connected to any Marsh server; or
                </li>
                <li>
                  disseminates unsolicited promotional or advertising material, spam or similar materials or any volume messages which may interfere with the operation of this Site or with the enjoyment of this Site by other visitors.
                </li>
              </ul>
            </li>
            <li>
              <strong>
                Linking.
              </strong>
              You may not make any part of the Site available as part of another website or application, whether by hyperlink framing on the Internet, caching or otherwise, unless you have been authorized to do so in writing by Marsh.  Marsh reserves the right to disable any unauthorized links or frames.  Marsh specifically disclaims any responsibility for the contents of any third-party websites or applications that link to this Site, and for any injury you may incur from third-party websites or applications linking or framing this Site.
            </li>
            <li>
              <strong>User Comments and Discussion Forums.</strong>
              We may provide an opportunity for you and other users to post comments or participate in discussion forums on this Site.  Marsh does not endorse any user posts and they should not be considered as reflecting the opinion of Marsh.  If you post any comments on this Site, you agree that you are entirely responsible for the content of your post and you will not post material that is inaccurate, contains personal information of yourself or a third party, promotes for sale and product or service, or violates the expectations for user conduct provided in paragraphs 5 and 6.  You also understand that anything you post will be considered non-confidential and non-proprietary, and you grant Marsh a limited license to use, store, and copy such content.
            </li>
            <h4>Site Purpose and Content</h4>
            <li>
              <strong>Intellectual Property.</strong>
              You understand and agree that the Site has been developed by Marsh and our licensors through the expenditure of substantial time, effort and money and constitutes valuable intellectual property and trade secrets of Marsh.  You further agree that the Site, including but not limited to text, content, photographs, video, audio and graphics is protected by copyrights, trademarks, service marks, international treaties and/or other proprietary rights and laws of the U.S. and other countries. The Site is also protected as a collective work or compilation under U.S. copyright and other laws and treaties. All individual articles, columns and other elements making up the Site are also copyrighted works. The trademarks, service marks, trade names, logos, designs, and sounds associated with the Site are owned by Marsh or third parties.  You agree to abide by all applicable copyright, trademark, and other laws, as well as any additional copyright notices or restrictions contained in the Site.  You may download materials from the Site and/or print a reasonable number of copies for your personal use or use within your organization, provided that all copies retain all copyright and other proprietary notices.
            </li>
            <li>
              <strong>
                License.
              </strong>
              You understand and agree that accessing and/or using the Site does not grant you any ownership, rights, or licenses to the Site other than the limited right to use the Site in accordance with the Terms.
            </li>
            <li>
              <strong>
                Site Content;Availability.
              </strong>
               You understand that the Site is provided “AS IS” and “AS AVAILABLE.”  Your access is limited by our Site functionality, your access levels, and the Terms.  Marsh reserves the right at any time and without notice to enhance, modify, alter, suspend or permanently discontinue all or any part of this Site and to restrict or prohibit access to it.
            </li>
            <li>
              <strong>
                Links to Third-Party Sites.
              </strong>
              Solely for your convenience, this Site may provide links and/or redirect you to third-party websites or applications.  Marsh has no control over third-party websites or applications, is not liable for their accuracy, content, or security, and makes no endorsement of third-party websites’ or applications’ owners, contents, or services.  Your use of third-party websites or applications is at your sole risk, so you should review the terms and conditions and privacy policies of any third party prior to use of their site.
            </li>
            <li>
              <strong>
                Global Access.
              </strong>
              Marsh is based in Thailand and provides this Site for use by persons located in Thailand.  We make no claims that the Site or any of its content is accessible or appropriate outside of Thailand, and you are responsible for ensuring any use you make of this Site complies with local law.
            </li>
            <li>
              <strong>
                <u>NO WARRANTIES. </u>
              </strong>
              <span class="underLine">You acknowledge and agree that this Site is provided by Marsh on an “AS IS” and “AS AVAILABLE” basis, without any warranties or guarantees.  To the extent permitted by law, Marsh disclaims all conditions, representations and warranties, express, implied, statutory or otherwise, including any warranties of merchantability, fitness for a particular purpose, title, accuracy of informational content, system integration, non-infringement of third party rights, quiet enjoyment, and uninterrupted or error free operation.</span>
            </li>
            <li>
              <strong >
                <u>DISCLAIMER OF LIABILITY. </u>
              </strong>
              <span class="underLine">Marsh and its subsidiaries, managers, employees, officers, agents, subcontractor, suppliers, and licensors accept no liability to you arising from your use of this Site. To the extent permitted by law, Marsh will not be liable to you for damages of any kind, whether foreseeable or unforeseeable, even if Marsh or any of its agents has been advised of the possibility of damages arising from your use of or reliance on the Site, including but not limited to direct, indirect, general, incidental, special, punitive, and consequential damages and damages for loss of use, loss of data, loss of goodwill, loss of profits, work stoppage, accuracy of results, or computer malfunction.</span>
            </li>
            <h4>Marsh’s Rights and Duties Regarding User Conduct and Submissions</h4>

            <li>
              <strong>
                Use of Information You Submit.
              </strong>
               By submitting information on this Site, you grant Marsh, its affiliated companies, its service providers, and sub-licensees permission to use your information in connection with the operation of their businesses including, without limitation, the rights to: copy, distribute, transmit, reproduce, edit, translate and reformat your information.  You agree that Marsh may use any information it collects in connection with this Site for data analytics purposes, including but not limited to benchmarking, modeling, consulting, creating insights, reports and other analytics to provide, improve the quality of, and market Marsh’s products and services.  Where required by law, we obtain your consent prior to such use and/or utilize de-identified and/or aggregated data for analytics.
            </li>
            <li>
              <strong>
                Privacy.
              </strong>
              You agree that all personal information you provide or that we collect about you through this Site is governed by our
              <a @click.stop="menuClicked('privacy-policy')">Privacy Policy</a>.
            </li>
            <li>
              <strong>
                Monitoring; Termination.
              </strong>
              Marsh, in its sole discretion, has the right to (i) remove or refuse to post any user content, (ii) disclose your identity or other information about you to any third party who claims that material posted by you violates their rights or in response to a subpoena, (iii) take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Site, and (iv) suspend your access to this Site and refuse to provide you with any further access to it or any content.  You agree that Marsh is not liable for any damages you may suffer from its exercise of these rights.
            </li>
            <li>
              <strong>
                Assignment.
              </strong>
              Marsh may assign these Terms and its rights and obligations under these Terms without your consent and at its sole discretion.  You may not assign or transfer your rights and obligations under these Terms.
            </li>
            <li>
              <strong>
                No Waiver.
              </strong>
              Marsh’s failure to assert its rights at any time will not be deemed a waiver of these Terms.  No consent or waiver will be effective unless in writing and signed by both parties.
            </li>
            <h4>Additional Legal Terms</h4>
            <li>
              <strong>
                Governing Law and Venue.
              </strong>
              You agree that any dispute arising out of or in connection with the Site or these Terms will be governed by the laws of the Republic of Thailand without reference to conflict of laws principles that would require the application of the laws of any other jurisdiction.  You agree to submit to the exclusive personal jurisdiction and venue of courts located in the Republic of Thailand.
            </li>
            <li>
              <strong>
                INDEMNIFICATION.
              </strong>
              <em>To the extent permitted by law, you agree to indemnify Marsh and its affiliates, employees, officers, directors, agents, successors, and assigns against any costs, claims, losses and damages (including legal fees) incurred by or awarded against Marsh as a result of your use of this Site or your breach of these Terms.</em>
            </li>
            <li>
              <strong>
                Invalidation of Terms.
              </strong>
              If a competent authority finds any portion of these Terms invalid or unenforceable, you agree that all other Terms will remain in effect.
            </li>
            <li>
              <strong>
                Void Where Prohibited; Restrictions.
              </strong>
              Marsh reserves the right to limit, in its sole discretion, the provision and quantity of any feature, product or service on this Site to any person or geographic area. Any offer for any feature, product or service made on the Site is void where prohibited. If you choose to access the Site from outside Thailand, you do so on your own initiative and you are solely responsible for complying with applicable local laws.  This Site is not intended or authorized (a) for use in any territory or by any party subject to sanctions or export restrictions under laws applicable to Marsh or you, or (b) in the case that Site access or use in a territory or by a party would expose Marsh or its affiliates to any sanction, prohibition or restriction under UN Security Council Resolutions or other trade or economic sanctions laws or regulations.   You may not use, export or re(export) this Site or any copy or adaptation of this Site in violation United Nations Security Council Resolutions or applicable laws.
            </li>
            <li>
              <strong>
                Entire Agreement.
              </strong>
              These terms and conditions of use constitute the entire agreement between
              the parties with respect to the subject matter hereof.
            </li>
            <h4>How to Contact Us</h4>
            <li>
              <strong>
                Contact.
              </strong>
              Any inquiries regarding this Site or these Terms should be emailed to <a href="mailto:asia.information@marsh.com">asia.information@marsh.com</a> or mailed to:
              <br/>
              <br/>
              <div>
                <strong>The Legal Department<br/></strong>
                <strong>c/o Marsh PB Co., Ltd</strong>
                <span>
              <br/>
              88 The PARQ, 6th Floor West Wing, Ratchadaphisek Road
            <br/>
            Klongtoey Subdistrict, Klongtoey District
            <br/>
            Bangkok 10110, Thailand
          </span>
              </div>
            </li>
          </ol>
        </v-col>
      </v-row>
    </v-row>
    <v-col
        cols="12"
        class="button-container col-12"
        v-if="!$store.state.isEditMode"
    >

      <v-btn
          class="ma-2 form-button continue right"
          dark
          color="#0080B4"
          @click="goHome"
      >
        <span class="home-icon"></span>
        Return Home
      </v-btn>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicySg",
  methods: {
    menuClicked: function (p) {
      switch (p) {
        case 'PICS':
          this.$store.state.formPageNumber = -1;
          break;
        case 'privacy-policy':
          this.$store.state.formPageNumber = -2;
          break;
        case 'terms-of-use':
          this.$store.state.formPageNumber = -3;
          break;
        default:
          this.$store.state.formPageNumber = 0;
          return;
      }

    },
    goHome: function() {
      this.$store.state.formPageNumber=0;
    }

  },
  computed: {
    getLang(){
      console.log(this.$store.state.country)
      //return this.$store.state.country === "hk" ? "hk" : "sg";
      if(this.$store.state.country === "hk"){
        return "hk";
      }else if(this.$store.state.country === "th"){
        return "th";
      }else {
        return "sg";
      }
    }
  }
}
</script>

<style scoped>

</style>
